import enLocale from "element-ui/lib/locale/lang/en"; //引入element语言包
//中文对应的英文
const en_US = {
  message: {
    info: {
      n1: "Verification Code Login",
      n2: "Email",
      n3: "Please enter email",
      n4: "Verification Code",
      n5: "Please enter verification code",
      n6: "Get Verification Code",
      n7: "Login",
      n8: "Register",
      n9: "Password Login",
      n10: "Password",
      n11: "Please enter password",
      n12: "Email error",
      n13: "Verification code sent",
      n14: "New Password",
      n15: "Confirm",
      n16: "Change Password",
      n17: "Logout",
      n18: "Home",
      n19: "International SMS",
      n20: "SMS Content",
      n21: "Send History",
      n22: "Balance: ",
      n23: "Balance Details",
      n24: "Balance Before",
      n25: "Operation Amount",
      n26: "Balance After",
      n27: "Business Type",
      n28: "Recharge",
      n29: "Consumption",
      n30: "Refund",
      n31: "Change Type",
      n32: "Increase",
      n33: "Decrease",
      n34: "Remarks",
      n35: "Operation Time",
      n36: "SMS Price",
      n37: "Area Code",
      n38: "Region Name",
      n39: "Price",
      n40: "Activation Status",
      n41: "Available",
      n42: "Unavailable",
      n43: "Update Time",
      n44: "SMS List",
      n45: "Please select send status",
      n46: "Pending",
      n47: "Sending",
      n48: "Completed",
      n49: "Pending Confirmation",
      n50: "Please select audit status",
      n51: "Pending Review",
      n52: "Approved",
      n53: "Rejected",
      n54: "Search",
      n55: "Reset",
      n56: "Add New",
      n57: "Content ID",
      n58: "SMS Content",
      n59: "Total Numbers",
      n60: "Success Count",
      n61: "Failure Count",
      n62: "Send Status",
      n63: "Audit",
      n64: "Send Start Time",
      n65: "Send End Time",
      n66: "Actions",
      n67: "Import Numbers",
      n68: "Import Completed",
      n69: "Delete",
      n70: "Add SMS Content",
      n71: "Please enter content (max 500 characters)",
      n72:
        "Note: SMS content will be sent directly to users, please confirm no sensitive information",
      n73: "Cancel",
      n74: "Import Phone Numbers",
      n75: "Recipient",
      n76: "Import Recipients",
      n77: "Add Recipient",
      n78:
        "Please download the template file and fill in phone numbers according to the template format",
      n79: "Download Template",
      n80: "Supports .xlsx, .xls, .csv formats",
      n81: "Drag file here, or",
      n82: "click to upload",
      n83: "Maximum 1 file per upload, file size not exceeding 5MB",
      n84: "Please select",
      n85: "Please enter content",
      n86: "Add More Numbers",
      n87: "Only",
      n88: "format files are supported",
      n89: "File size cannot exceed",
      n90: "Are you sure you want to delete?",
      n91: "Prompt",
      n92: "Send List",
      n93: "Please enter SMS content ID",
      n94: "Please select area code",
      n95: "Please enter recipient phone number",
      n96: "Please select status",
      n97: "Pending",
      n98: "Sending",
      n99: "Success",
      n100: "Failed",
      n101: "Area Code",
      n102: "Recipient Phone Number",
      n103: "Amount Consumed",
      n104: "Please enter the password again",
      n105: "Two passwords are inconsistent",
      n106: "new password",
      n107: "Please enter keyword",
      n108: "Please enter Google API Key",
      n109: "Add",
      n110: "Keyword",
      n111: "Longitude",
      n112: "Latitude",
      n113: "Edit",
      n114: "New",
      n115: "Google API Key:",
      n116: "Count",
      n117: "Name",
      n118: "Address",
      n119: "Phone",
      n120: "Create Time",
      n121: "View Data",
      n122: "Download",
      n123: "Collecting",
      n124: "Success",
      n125: "Failed",
      n126: "Status",
      n127: "Google Collection",
      n128: "Please enter content",
      n129: "Please select coordinates",
      n130: "Select Point",
      n131: "View",
      n132: "Center Location",
      n133: "Confirm",
      n134: "Select Map Location",
      n135: "Search Location",
      n136: "Current Selected Coordinates",
      n137: "Please enter search keyword",
      n138: "Please select center location",
      n139: "Location not found, please try another keyword",
      n140: "Please select a location on the map first",
      n141: "Download failed",
      n142: "Download successful",
      n143: "Download request failed"
    }
  },
  ...enLocale
};

export default en_US;



// WEBPACK FOOTER //
// ./src/assets/i18n/langs/en_US.js